module.exports = __webpack_public_path__ + "img/campaign-art-placeholder.6a5eb91.png";